<section class="aoh row row-20 makePaymentView" id="productList-area">
  <aside id="filter-aside" class="col-md-3 col-sm-3 col-lg-2 col-xs-12 applied-filter pr-0">
    <fieldset id="filter-by">
      <legend class="filterByTitle-main order-history-search">
        {{ "ordersList.searchBy" | cxTranslate }}
      </legend>
      <div class="grey-line"></div>
      <div class="filterByGroup">
        <div class="filterByTitle filter-align asmSearchSpace">
          <label for="invoice">{{
            "ordersList.b2BUnit" | cxTranslate
          }}</label>
        </div>
        <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
          bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="b2BUnitFilter">
        </ng-select>
        <label class="searchbox orders-filter time-frame">
          <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
            aria-autocomplete="both" class="Fields-input" [(ngModel)]="b2BUnitId" />
        </label>
      </div>
      <div class="filterByGroup">
        <div class="filterByTitle filter-align asmSearchSpace">
          <label for="invoice">{{
            "ordersList.email" | cxTranslate
          }}</label>
        </div>
        <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
          bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="emailFilter">
        </ng-select>
        <label class="searchbox orders-filter time-frame">
          <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
            aria-autocomplete="both" class="Fields-input" [(ngModel)]="emailId" />
        </label>
      </div>
      <div class="filterByGroup">
        <div class="filterByTitle filter-align asmSearchSpace">
          <label for="invoice">{{
            "ordersList.cusName" | cxTranslate
          }}</label>
        </div>
        <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
          bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="cusNameFilter">
        </ng-select>
        <label class="searchbox orders-filter time-frame">
          <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
            aria-autocomplete="both" class="Fields-input" [(ngModel)]="customerName" />
        </label>
      </div>
      <div class="filterByGroup">
        <div class="filterByTitle filter-align asmSearchSpace">
          <label for="invoice">{{
            "ordersList.userName" | cxTranslate
          }}</label>
        </div>
        <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
          bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="userNameFilter">
        </ng-select>
        <label class="searchbox orders-filter time-frame">
          <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
            aria-autocomplete="both" class="Fields-input" [(ngModel)]="userName" />
        </label>
      </div>
      <div class="account-order-filter-btn btn-align">
        <button type="submit" id="searchUserForASM" class="btn-primary" data-di-id="di-id-362f2c77-5f23e741"
          (click)="applyFilter(0)">
          {{ "ordersList.applyFilters" | cxTranslate }}
        </button>
        <button type="button" id="clearOrderFiltersBtn" class="btn-secondary" data-di-id="#clearOrderFiltersBtn"
          (click)="clearFilters()">
          {{ "ordersList.clearFilters" | cxTranslate }}
        </button>
      </div>
    </fieldset>
    <div class="line-intersection"></div>
  </aside>
  <section class="col-md-9 col-sm-9 col-lg-10 table-s-section  order-history-right float-right">
    <section class="filter-section">
      <section class="row">
        <section class="col-sm-12 col-md-12 col-md-12 col-xs-12 op_ovice">
          <div id="filter-applied" class="asm-filter-applied asmTopSpace">
            <hr class="hidden-xs" />
            <div class="row row-20">
              <div class="col-4 hidden-xs filterApply-showing">
                <span class="total-records">{{ "ordersList.totalRecords" | cxTranslate
                }}={{totalRecords?.totalResults?totalRecords?.totalResults:0}}</span>
                <span class="#" id="userAccMngmnt">
                  <a aria-label="anchor_img_XLS" class="anchor_img_XLS" id="orderXLS" (click)="generateXls()">
                    <img src="/icons/{{baseSiteId}}/excel_new.png" alt="User Access Records" style="padding-left: 20px;
                  margin-right: 5px;" />
                    <span></span>
                    <span class="pdf-text XLS_span">{{
                      "ordersList.xls" | cxTranslate
                    }}</span>
                  </a>
                </span>
              </div>
              <div class="col-4 hidden-xs top-pagination d-lg-flex justify-content-end">
                <div class="time-frame">
                  <span id="accPageInfo" class="top-page-id">Page
                    {{totalRecords?.totalPages>0?totalRecords?.currentPage+1:0}} of
                  {{totalRecords?.totalPages?totalRecords?.totalPages:0}}</span>
                  <div class="pagination">
                    <button class="pagination-btns mr-1" [disabled]="!totalRecords ||totalRecords?.currentPage === 0"
                      (click)="paginationPrev()">
                      <span class="chevronIconWhite prev"> &lt; </span>
                    </button>
                    <button class="pagination-btns"
                      [disabled]="(totalRecords?.currentPage+1) === totalRecords?.totalPages || totalRecords?.totalPages===0 || !totalRecords"
                      (click)="paginationNext()">
                      <span class="chevronIconWhite next"> &gt; </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-4 col-xs-12 sortBy-select px-12 asm_row_per_page">
                <ng-select id="pageSize" name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false"
                  bindLabel="name" bindValue="code" class="set-pagination" [(ngModel)]="pageSizeperPage"
                (ngModelChange)="changePageSize()"></ng-select>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>

    <section class="payment-section filter-section">
      <section class="dispaly-refine">
        <ng-template #facetsRwd class="select-refine">
          <section class="modal-class">
            <section class="modal-heading">
              <h2>
                <span class="close-icon" aria-hidden="true" (click)="hide()">&times;</span>
              </h2>
              <h2 class="select-heading">
                {{ "plp.selectRefinement" | cxTranslate }}
              </h2>
            </section>
            <section>
              <fieldset id="filter-by">
                <legend class="filterByTitle-main order-history-search">
                  {{ "ordersList.searchBy" | cxTranslate }}
                </legend>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle filter-align asmSearchSpace">
                    <label for="invoice">{{
                      "ordersList.b2BUnit" | cxTranslate
                    }}</label>
                  </div>
                  <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="b2BUnitFilter">
                  </ng-select>
                  <label class="searchbox orders-filter time-frame">
                    <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
                      aria-autocomplete="both" class="input-filter" [(ngModel)]="b2BUnitId" />
                  </label>
                </div>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle filter-align asmSearchSpace">
                    <label for="invoice">{{
                      "ordersList.email" | cxTranslate
                    }}</label>
                  </div>
                  <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="emailFilter">
                  </ng-select>
                  <label class="searchbox orders-filter time-frame">
                    <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
                      aria-autocomplete="both" class="input-filter" [(ngModel)]="emailId" />
                  </label>
                </div>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle filter-align asmSearchSpace">
                    <label for="invoice">{{
                      "ordersList.cusName" | cxTranslate
                    }}</label>
                  </div>
                  <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="cusNameFilter">
                  </ng-select>
                  <label class="searchbox orders-filter time-frame">
                    <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
                      aria-autocomplete="both" class="input-filter" [(ngModel)]="customerName" />
                  </label>
                </div>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle filter-align asmSearchSpace">
                    <label for="invoice">{{
                      "ordersList.userName" | cxTranslate
                    }}</label>
                  </div>
                  <ng-select name="b2BUnitFilter" [items]="searchFilters" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="userNameFilter">
                  </ng-select>
                  <label class="searchbox orders-filter time-frame">
                    <input type="text" autocomplete="off" aria-describedby="initialDescription" aria-controls="results"
                      aria-autocomplete="both" class="input-filter" [(ngModel)]="userName" />
                  </label>
                </div>
                <div class="account-order-filter-btn">
                  <button type="submit" class="btn-primary" data-di-id="di-id-362f2c77-5f23e741"
                    (click)="applyFilter(0)">
                    {{ "ordersList.applyFilters" | cxTranslate }}
                  </button>
                  <button type="button" id="clearOrderFiltersBtn" class="btn-secondary"
                    data-di-id="#clearOrderFiltersBtn" (click)="clearFilters()">
                    {{ "ordersList.clearFilters" | cxTranslate }}
                  </button>
                </div>
              </fieldset>
            </section>
          </section>
        </ng-template>
        <div class="account-order-filter-btn mb-1">
          <button class="btn-secondary" data-di-id="#refineBtn" (click)="refine()">
            {{ "ordersList.refine" | cxTranslate }}
          </button>
        </div>
        <div class="sortBy-select pb-4 mobile-view-select">
          <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
            bindValue="code" class="dropdown-credit set-pagination" [(ngModel)]="pageSizeperPage"
          (ngModelChange)="changePageSize()"></ng-select>
        </div>
        <div>
          <span class="total-records">{{ "ordersList.totalRecords" | cxTranslate
          }}={{totalRecords?.totalResults?totalRecords?.totalResults:0}}</span>
          <a aria-label="download order history as" id="orderXLSRWD" aria-label="anchor_img_XLS" class="anchor_img_XLS"
            (click)="generateXls()">
            <img src="/icons/{{baseSiteId}}/excel_new.png" alt="pdf" class="ad-pdf xls-img" />
            <span></span>
            <span class="pdf-text pl-1 XLS_span">{{
              "ordersList.xls" | cxTranslate
            }}</span>
          </a>
        </div>
      </section>
      <table aria-describedby="invoicesTable" id="ordersTable" class="order-list-table table table-striped">
        <thead>
          <tr class="heading">
            <th scope="col" class="date-title">
              {{ "ordersList.b2bTableLabel" | cxTranslate }}

            </th>
            <th scope="col" class="type-title">
              {{ "ordersList.b2bNameTableLabel" | cxTranslate }}

            </th>
            <th scope="col" class="order-title">
              {{ "ordersList.b2bCusName" | cxTranslate }}

            </th>
            <th scope="col" class="status-title">
              {{ "ordersList.email" | cxTranslate }}

            </th>
            <th scope="col" class="po-title">
              {{ "ordersList.userName" | cxTranslate }}

            </th>
            <th scope="col" class="invoice-title">
              {{ "ordersList.userIDdis" | cxTranslate }}
            </th>
            <th scope="col" class="tracking-title">
              {{ "ordersList.viewActionButton" | cxTranslate }}
            </th>
          </tr>
        </thead>
        <tbody class="datatable-row">
          @for (
            data of b2bUnitUsers; track
            data) {
            <tr>
              <td>
                <span>{{ data?.unitId }}</span>
              </td>
              <td>
                <span>{{ data?.unitName }}</span>
              </td>
              <td>
                <span>{{ data?.customerName }}</span>
              </td>
              <td>
                <span>{{ data?.email }}</span>
              </td>
              <td>
                <span>{{ data?.userName }}</span>
              </td>
              <td>
                <span>{{ data?.userDisabled?'Y':'N' }}</span>
              </td>
              <td class="viewCol">
                <button type="button" (click)="openCustomerDetails(data?.userName)" class="btn btn-primary viewBtn">
                  {{ "ordersList.viewButton" | cxTranslate }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (b2bUnitUsers?.length===0) {
        <section class="text-center">
          {{ "ordersList.noRecords" | cxTranslate }}
        </section>
      }
      <section class="orders-table-orders">
        @for (data of b2bUnitUsers; track data) {
          <div class="orders-row-table">
            <div class="column header-column orders-table-col">
              <section class="col-header-rwd">
                <p class="table-sm-header">
                  <b>{{ "ordersList.b2bTableLabel" | cxTranslate }}</b>
                </p>
                <p class="table-sm-value">
                  {{ data?.unitId }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.b2bNameTableLabel" | cxTranslate }}
                  </b>
                </p>
                <p class="table-sm-value">
                  {{ data?.unitName }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.b2bCusName" | cxTranslate }}
                  </b>
                </p>
                <p class="table-sm-value">
                  {{ data?.customerName }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.email" | cxTranslate }}
                  </b>
                </p>
                <p class="table-sm-value">
                  {{ data?.email }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.userName" | cxTranslate }}
                  </b>
                </p>
                <p class="table-sm-value">
                  {{ data?.userName }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.userIDdis" | cxTranslate }}
                  </b>
                </p>
                <p class="table-sm-value">
                  {{ data?.userDisabled?'Y':'N' }}
                </p>
                <p class="table-sm-header">
                  <b>
                    {{ "ordersList.viewActionButton" | cxTranslate }}
                  </b>
                </p>
                <p>
                  <button type="button" (click)="openCustomerDetails(data?.userName)" class="btn-primary viewBtn">
                    {{ "ordersList.viewButton" | cxTranslate }}
                  </button>
                </p>
              </section>
            </div>
          </div>
        }
      </section>

    </section>
    <section>
      <div class="top-pagination text-center dispaly-refine display-pag">
        <div class="">
          <span id="accPageInfo" class="top-page-id mr-2 pt-1">Page
            {{totalRecords?.totalPages>0?totalRecords?.currentPage+1:0}} of
          {{totalRecords?.totalPages?totalRecords?.totalPages:0}}</span>
          <div class="">
            <button class="pagination-btns mr-1" [disabled]="!totalRecords || totalRecords?.currentPage === 0"
              (click)="paginationPrev()">
              <span class="chevronIconWhite prev"> &lt; </span>
            </button>
            <button class="pagination-btns"
              [disabled]="(totalRecords?.currentPage+1) === totalRecords?.totalPages || totalRecords?.totalPages===0 || !totalRecords"
              (click)="paginationNext()">
              <span class="chevronIconWhite next"> &gt; </span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="line-intersection mobile-view"></div>
  </section>
</section>
